import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  freeSpinActive: false,
  showFreeSpinGame: false,
  isFreeSpinMode: false, // Indicates if the application is currently in free spin mode.
  freeSpinsComplete: false,
  freeSpinsLeft: 0,
};

const freeSpinsSlice = createSlice({
  name: "freeSpins",
  initialState,
  reducers: {
    setFreeSpinActive(state, action) {
      state.freeSpinActive = action.payload;
    },

    setShowFreeSpinGame(state, action) {
      state.showFreeSpinGame = action.payload;
    },

    setFreeSpinsComplete(state, action) {
      state.freeSpinsComplete = action.payload;
    },

    setFreeSpinsLeft(state, action) {
      state.freeSpinsLeft = action.payload;
    },

    setFreeSpinMode: (state, action) => {
      state.isFreeSpinMode = action.payload;
    },

    resetFreeSpinsState(state) {
      return initialState;
    },
  },
});

export const {
  setFreeSpinActive,
  setFreeSpinMode,
  resetFreeSpinsState,
  setFreeSpinsComplete,
  setFreeSpinsLeft,
  setShowFreeSpinGame,
} = freeSpinsSlice.actions;

export default freeSpinsSlice.reducer;
